export const campaignMetricsHeaders = [
  {
    label: "Campaign Name",
    key: "name",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
  },
  {
    label: "Lead Generated",
    key: "leadsGenerated",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
    valueGetter: (row: any) => {
      return row.leadsGenerated || 0;
    },
  },
  {
    label: "Opportunities Created",
    key: "opportunitiesCreated",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
    valueGetter: (row: any) => {
      return row.opportunitiesCreated || 0;
    },
  },
  {
    label: "Revenue",
    key: "revenue",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
  },
  {
    label: "Campaign Cost",
    key: "campaignCost",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
  },
  {
    label: "ROI",
    key: "roi",
    classNameGetter: (row: any, data: any, index: any) => {
      return index === data?.length - 1 ? "table-last-row" : "";
    },
  },
];

export const campaignMetricsData = [
  {
    campaignName: "Campaign Name",
    leadGenerated: 120,
    opportunitiesCreated: 30,
    revenue: "$12,000",
    campaignCost: "$4,000",
    ROI: "200%",
  },
  {
    campaignName: "Campaign Name",
    leadGenerated: 200,
    opportunitiesCreated: 60,
    revenue: "$25,000",
    campaignCost: "$7,000",
    ROI: "257%",
  },
  {
    campaignName: "Campaign Name",
    leadGenerated: 80,
    opportunitiesCreated: 20,
    revenue: "$6,500",
    campaignCost: "$3,000",
    ROI: "117%",
  },
  {
    campaignName: "Campaign Name",
    leadGenerated: 150,
    opportunitiesCreated: 50,
    revenue: "$18,000",
    campaignCost: "$6,000",
    ROI: "200%",
  },
];
